import { render, staticRenderFns } from "./points_task_smartPoster.vue?vue&type=template&id=30b6feca&scoped=true"
import script from "./points_task_smartPoster.vue?vue&type=script&lang=js"
export * from "./points_task_smartPoster.vue?vue&type=script&lang=js"
import style0 from "./points_task_smartPoster.vue?vue&type=style&index=0&id=30b6feca&prod&lang=scss&scoped=true"
import style1 from "./points_task_smartPoster.vue?vue&type=style&index=1&id=30b6feca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b6feca",
  null
  
)

export default component.exports